import React, { useRef } from "react";
import Card from "~/admin/components/Card";
import Table from "~/admin/components/Table";
import Td from "~/admin/components/Td";
import Th from "~/admin/components/Th";
import Tr from "~/admin/components/Tr";
import { Bookmark, Pencil } from "phosphor-react";
import Button from "~/admin/components/Button";
import Notifications from "~/admin/services/Notifications";
import CreateCategoryModal from "./components/CreateCategoryModal";
import UpdateCategoryModal from "./components/UpdateCategoryModal";

export default function CategoriesTab({ categories, reload }) {
  const createCategoryModal = useRef();
  const updateCategoryModal = useRef();

  const onCreated = async (id) => {
    Notifications.success("Catégorie créée avec succès");
    reload();
  };

  const onUpdated = async (id) => {
    Notifications.success("Catégorie modifiée avec succès");
    reload();
  };

  return (
    <>
      <Button
        color="tertiary"
        size="s"
        className="mb-4"
        icon={<Bookmark />}
        onClick={() => createCategoryModal.current?.open()}
      >
        Ajouter une catégorie
      </Button>
      <Card>
        <Table>
          <thead>
            <Tr>
              <Th>Nom</Th>
              <Th>Nombre d'influenceurs</Th>
              <Th>Nombre d'entreprises</Th>
              <Th></Th>
            </Tr>
          </thead>
          <tbody>
            {categories.map((category) => {
              return (
                <Tr key={category.id}>
                  <Td>{category.name}</Td>
                  <Td>{category.influencers_count}</Td>
                  <Td>{category.companies_count}</Td>
                  <Td isActions>
                    <Pencil
                      className="cursor-pointer hover:text-gray-400"
                      size={24}
                      onClick={() => {
                        updateCategoryModal?.current?.open(category.id);
                      }}
                    />
                  </Td>
                </Tr>
              );
            })}
          </tbody>
        </Table>
      </Card>
      <CreateCategoryModal ref={createCategoryModal} onSubmitted={onCreated} />
      <UpdateCategoryModal ref={updateCategoryModal} onSubmitted={onUpdated} />
    </>
  );
}
